<template>
  <div class="page flex-col">
    <div class="group_8 flex-col">
      <div class="box_27 flex-col">
        <div class="text-wrapper_1">
          <span class="text_4">{{ $t("Decentralization") }}</span>
          <span class="text_5">{{ $t("Coin-based") }}</span>
          <span class="text_6">{{ $t("Perpetual Options") }}</span>
        </div>
        <span class="text_7">{{ $t("Future Derivatives Infrastructure") }}</span>
        <div class="text-wrapper_2 flex-col pointer" @click="goUrl('https://appv2.fufuture.io')"><span
            class="text_8">{{ $t("Start Trading") }}</span></div>

      </div>
      <div class="section_7 flex-col">
        <div class="box_2">
          <img
              class="image_1"
              referrerpolicy="no-referrer"
              src="./assets/img/logo.svg"
          />
          <div class="box_2_1">
            <span class="text_1 pointer" @click="goUrl('https://appv2.fufuture.io')">{{ $t("Trading") }}</span>
            <span class="text_1 pointer" @click="goUrl('https://follow.fufuture.io')">{{ $t("Follow") }}</span>
            <span class="text_1 pointer"
                  @click="goUrl('https://appv2.fufuture.io/u/pools')">{{ $t("Fund Pool") }}</span>
            <span class="text_1 pointer"
                  @click="goUrl('https://appv2.fufuture.io/u/referral')">{{ $t("Recommendation Reward") }}</span>
            <a-dropdown class="lang">
              <a class="ant-dropdown-link">
                <img width="100%" height="100%" src="./assets/img/lang.png"/>
              </a>
              <a-menu slot="overlay" class="lang-bg">
                <a-menu-item>
                  <a href="javascript:;" class="lang-title">{{ $t("Language") }}</a>
                </a-menu-item>
                <a-menu-item>
                  <a href="javascript:;" class="lang-item" @click="changeLang('zh')">简体中文</a>
                </a-menu-item>
                <a-menu-item>
                  <a href="javascript:;" class="lang-item" @click="changeLang('zh_HK')">繁體中文</a>
                </a-menu-item>
                <a-menu-item>
                  <a href="javascript:;" class="lang-item" @click="changeLang('en')">English</a>
                </a-menu-item>
                <a-menu-item>
                  <a href="javascript:;" class="lang-item" @click="changeLang('ja')">日本語</a>
                </a-menu-item>
                <a-menu-item>
                  <a href="javascript:;" @click="changeLang('ko')">한국어</a>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </div>
          <a-dropdown class="box_2_2">
            <a class="ant-dropdown-link">
              <img src="./assets/img/menu.svg" class="menu"/>
            </a>
            <a-menu slot="overlay" class="menu-content">
              <a-menu-item>
                <a href="javascript:;" class="menu-item pointer"
                   @click="goUrl('https://appv2.fufuture.io')">{{ $t("Trading") }}</a>
              </a-menu-item>
              <a-menu-item>
                <a href="javascript:;" class="menu-item pointer"
                   @click="goUrl('https://follow.fufuture.io')">{{ $t("Follow") }}</a>
              </a-menu-item>
              <a-menu-item>
                <a href="javascript:;" class="menu-item pointer"
                   @click="goUrl('https://appv2.fufuture.io/u/pools')">{{ $t("Fund Pool") }}</a>
              </a-menu-item>
              <a-menu-item>
                <a href="javascript:;" class="menu-item pointer" @click="goUrl('https://appv2.fufuture.io/u/referral')">{{
                    $t("Recommendation Reward")
                  }}</a>
              </a-menu-item>
              <a-menu-item>
                <a href="javascript:;" class="menu-item" @click.stop="showLang">{{ $t("Language") }}
                  <img
                      class="thumbnail_16"
                      referrerpolicy="no-referrer"
                      :src="showLangTag"
                  />
                </a>
                <div class="menu-c" v-show="isShowLang">
                  <div class="menu-item" @click="changeLang('zh')">简体中文</div>
                  <div class="menu-item" @click="changeLang('zh_HK')">繁體中文</div>
                  <div class="menu-item" @click="changeLang('en')">English</div>
                  <div class="menu-item" @click="changeLang('ja')">日本語</div>
                  <div class="menu-item" @click="changeLang('ko')">한국어</div>
                </div>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </div>
      </div>
    </div>
    <div class="group_notice">
      <div class="box_3 flex-row">
        <img
            class="label_1"
            referrerpolicy="no-referrer"
            src="./assets/img/announcement.svg"
        />
        <vue-marquee-slider
            id="marquee-slider-loop"
            :speed="20000"
            :width="200"
            :space="150"
            :paused="hoverPause"
            :key="marqueeKey"

        >
          <span class="text_9"
                @mouseenter="setHoverPause(true)"
                @mouseleave="setHoverPause(false)"
                v-for="(item,key) in notice" :key="key" @click="goUrl(item.url)">{{ item.text }}</span>
        </vue-marquee-slider>
      </div>
    </div>
    <div class="group_9 flex-col">
      <div class="group_10 flex-row">
        <div class="block_1 flex-col">
          <div class="block_4 flex-col justify-between">
            <div class="image-wrapper_13 flex-col">
              <img
                  class="image_25"
                  referrerpolicy="no-referrer"
                  src="./assets/img/char1.svg"
              />
            </div>
          </div>
          <div class="text-group_14 flex-col justify-between">
            <span class="text_12">{{ $t("Never Liquidate") }}</span>
            <div class="text-wrapper_3">
              <span class="text_13">{{ $t("Eliminate Liquidation Risk") }}<br/>{{ $t("Risk Management Easier") }}</span>
              <span class="text_14">{{ $t("Eliminate Liquidation Risk") }}, {{ $t("Risk Management Easier") }}</span>
            </div>
          </div>
        </div>
        <div class="block_2 flex-col">
          <div class="block_4 flex-row">
            <img
                class="image_25"
                referrerpolicy="no-referrer"
                src="./assets/img/char2.svg"
            />

          </div>
          <div class="text-group_14 flex-col justify-between">
            <span class="text_12">{{ $t("High Leverage") }}</span>
            <div class="text-wrapper_3">
              <span class="text_13">25-500 {{ $t("Multiple Leverage") }} <br/>{{ $t("High Profit Potential") }}</span>
              <span class="text_14">25-500 {{ $t("Multiple Leverage") }}, {{ $t("High Profit Potential") }}</span>
            </div>
          </div>
        </div>
        <div class="block_3 flex-col">
          <div class="block_4 flex-col">
            <div class="image-wrapper_15 flex-row">
              <img
                  class="image_25"
                  referrerpolicy="no-referrer"
                  src="./assets/img/char3.svg"
              />
            </div>
          </div>
          <div class="text-group_14 flex-col justify-between">
            <span class="text_12">{{ $t("Zero Slippage") }}</span>
            <div class="text-wrapper_3">
              <span class="text_13">{{ $t("Execution Price Meets Expected Results") }}<br/>{{ $t("Eliminate Impermanent Loss") }}</span>
              <span class="text_14">{{ $t("Execution Price Meets Expected Results") }}, {{ $t("Eliminate Impermanent Loss") }}</span>
            </div>
          </div>
        </div>
        <div class="group_1 flex-col">
          <div class="block_4 flex-col">
                <img
                    class="image_25"
                    referrerpolicy="no-referrer"
                    src="./assets/img/char4.svg"
                />
          </div>
          <div class="text-group_14 flex-col justify-between">
            <span class="text_12">{{ $t('Dual liquidity pool') }}</span>
            <div class="text-wrapper_3">
              <span class="text_13">{{ $t('Open liquidity pool') }}<br/>{{ $t('More stable liquidity') }}</span>
              <span class="text_14">{{ $t('Open liquidity pool') }}, {{ $t('More stable liquidity') }}</span>
            </div>
          </div>
        </div>
        <div class="group_2 flex-col">
          <div class="block_4 flex-col">
            <img
                class="image_25"
                referrerpolicy="no-referrer"
                src="./assets/img/char5.svg"
            />
          </div>
          <div class="text-group_14 flex-col justify-between">
            <span class="text_12">{{ $t('Reasonable pricing') }}</span>
            <div class="text-wrapper_3">
              <span class="text_13">{{ $t('Price feed from third-party oracle') }}<br/>{{ $t('Precise error control') }}</span>
              <span class="text_14">{{ $t('Price feed from third-party oracle') }}, {{ $t('Precise error control') }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="text-wrapper_8 flex-col"><span class="text_28">{{ $t("Commission Rate 15%") }}</span></div>
      <span class="text_29">{{ $t("Generous recommendation rewards, recognize your contribution") }}</span>
      <span class="text_291" v-html="this.$t('Generous recommendation rewards, recognize your contribution2')"></span>
      <div class="invite">
        <div class="section_8 flex-col">
          <img src="./assets/img/invite_1.svg"/>
        </div>
        <div class="text-group_19 flex-col justify-between">
          <span class="text_30">{{ $t("Invite a friend") }}</span>
          <span class="text_31">{{ $t("Invite a friend to Fufuture via a referral link") }}</span>
        </div>
        <div class="text-group_19 flex-col justify-between">
          <span class="text_30">{{ $t("Friend completes first order") }}</span>
          <span class="text_31">{{ $t("Friend accepts invitation and completes first order") }}</span>
        </div>
        <div class="image-wrapper_18 flex-col">
          <img src="./assets/img/invite_2.svg"/>
        </div>
        <div class="image-wrapper_19 flex-col">
          <img src="./assets/img/invite_3.svg"/>
        </div>
        <div class="text-group_19 flex-col justify-between">
          <span class="text_30">{{ $t("Get your commission") }}</span>
          <span class="text_31">{{ $t("Get your commission immediately and claim it anytime") }}</span>
        </div>
      </div>
      <div class="text-wrapper_9 flex-col pointer" @click="goUrl('https://appv2.fufuture.io/u/referral')"><span
          class="text_36">{{ $t("Create my link") }}</span></div>
      <span class="text_37">{{ $t("Deep liquidity supported by dual pools") }}</span>
      <div class="text-wrapper_16 flex-row">
        <div :class="key===sliderValue?'coin-item-active':'coin-item'" v-for="(item,key) in hotCoin" :key="key">
          <div class="text_38">{{ item.symbol }}</div>
          <div :class="(key===sliderValue?'slide-active text_41':'text_41')">BTC-{{ item.symbol }}</div>
        </div>
      </div>

      <div class="swiper">
        <slider animation="fade" autoplay="true"
                v-model="sliderValue"
                stopOnHover="true"
                interval="30000"
                height="186px"
                width="1230px"
                style="margin: auto"
                left-icon="./assets/img/slide_left.svg"
                right-icon="./assets/img/slide_right.svg"
                :indicators="false"
        >
          <slider-item v-for="(i, index) in hotCoin" :key="index">
            <div class="group_22 flex-row justify-between">
              <div class="group_23 flex-col">
                <div class="text-wrapper_18 flex-row justify-between">
                  <span class="text_44">{{ $t("Public pool") }}</span>
                  <span class="text_45">{{ $t("Available liquidity") }}</span>
                </div>
                <div class="image-text_4 flex-col justify-between">
                  <div class="image_5">
                    <div class="image_5_1" :style="{width:hotCoin[sliderValue].pubRate+'%'}"></div>
                    <div class="image_5_2"></div>
                  </div>
                  <span class="text-group_9">{{ hotCoin[sliderValue].pubRate }}%</span>
                </div>
              </div>
              <div class="group_7 flex-col">
                <div class="text-wrapper_19 flex-row justify-between">
                  <span class="text_46">{{ $t("Private pool") }}</span>
                  <span class="text_47">{{ $t("Available liquidity") }}</span>
                </div>
                <div class="image-text_5 flex-col justify-between">
                  <div class="image_5">
                    <div class="image_5_1" :style="{width:hotCoin[sliderValue].priRate+'%'}"></div>
                    <div class="image_5_2"></div>
                  </div>
                  <span class="text-group_10">{{ hotCoin[sliderValue].priRate }}%</span>
                </div>
              </div>
            </div>
          </slider-item>
        </slider>
      </div>

      <div class="text-wrapper_14 flex-col pointer" @click="goUrl('https://appv2.fufuture.io/u/pools')"><span
          class="text_48">{{ $t("Add LP") }}</span></div>
      <div class="box_13 flex-col">
        <div class="list_2 flex-row">
          <div class="text-group_22 flex-col justify-between" v-for="(item, index) in loopData0" :key="index">
            <span class="text_49" v-html="item.lanhutext0"></span>
            <span class="text_50" v-html="item.lanhutext1"></span>
          </div>
        </div>
      </div>
      <span class="text_51">{{ $t("FAQ") }}</span>
      <div class="qa">
        <div v-for="(item,key) in qa" :key="key" class="group_24 flex-row justify-between" @click="showQa(key)">
          <div class="text-group_23 flex-col justify-between">
            <span class="text_52">{{ item.title }}</span>
            <div class="text-wrapper_15" :id="'content_'+key">
              <span class="text_53">{{ item.content }}</span>
            </div>
          </div>
          <div class="image-wrapper_20 flex-col">
            <img
                class="thumbnail_16"
                :id="'qa_'+key"
                referrerpolicy="no-referrer"
                src="./assets/img/right.svg"
            />

          </div>
        </div>

      </div>
      <div class="group_28 flex-row justify-between">
        <vue-marquee-slider
            id="marquee-slider-loop2"
            :speed="40000"
            :width="100"
            :space="this.logoGap"
            :key="logoKey0"

        >
          <div class="image-wrapper_1 flex-col" v-for="(item,key) in roundLogo" :key="key">
            <img
                class="image_7"
                referrerpolicy="no-referrer"
                :src="item"
            />
          </div>

        </vue-marquee-slider>
      </div>
      <div class="group_29 flex-row justify-between">
        <vue-marquee-slider
            id="marquee-slider-loop3"
            :speed="40000"
            :width="100"
            :space="this.logoGap"
            :key="logoKey1"
        >
          <div class="image-wrapper_1 flex-col" v-for="(item,key) in roundLogo2" :key="key">
            <img
                class="image_7"
                referrerpolicy="no-referrer"
                :src="item"
            />
          </div>
        </vue-marquee-slider>
      </div>
      <div class="box_24 flex-col">
        <div class="footer">
          <div class="group_30 flex-row">
            <div class="image-text_6 flex-col justify-between">
              <img
                  class="image_17"
                  referrerpolicy="no-referrer"
                  src="./assets/img/logo.svg"
              />
              <span class="text-group_13">{{ $t("Future Derivatives Infrastructure") }}</span>
            </div>
            <div class="image-wrapper_9 flex-row">
              <img
                  class="thumbnail_5"
                  referrerpolicy="no-referrer"
                  src="./assets/img/twitter.png"
                  @click="goUrl('https://twitter.com/fufuture_io')"
                  title="X/Twitter"
                  alt="X/Twitter"
              />

              <img
                  class="thumbnail_5"
                  referrerpolicy="no-referrer"
                  src="./assets/img/medium.png"
                  @click="goUrl('https://medium.com/@Fufuture')"
                  alt="Medium"
                  title="Medium"
              />

<!--              <img-->
<!--                  class="thumbnail_5"-->
<!--                  referrerpolicy="no-referrer"-->
<!--                  src="./assets/img/telegram.png"-->
<!--                  @click="goUrl('')"-->
<!--                  alt="Telegram"-->
<!--              />-->
<!--              <img-->
<!--                  class="thumbnail_5"-->
<!--                  referrerpolicy="no-referrer"-->
<!--                  src="./assets/img/discord.png"-->
<!--                  @click="goUrl('')"-->
<!--                  alt="Discord"-->
<!--              />-->
<!--              <img-->
<!--                  class="thumbnail_5"-->
<!--                  referrerpolicy="no-referrer"-->
<!--                  src="./assets/img/sd.png"-->
<!--                  alt="Sd"-->
<!--              />-->
<!--              <img-->
<!--                  class="thumbnail_5"-->
<!--                  referrerpolicy="no-referrer"-->
<!--                  src="./assets/img/coinmarketcap.svg"-->
<!--              />-->
              <img
                  class="thumbnail_5"
                  referrerpolicy="no-referrer"
                  src="./assets/img/github.png"
                  @click="goUrl('https://fufuture.gitbook.io/fufuture')"
              />
              <img
                  class="thumbnail_5"
                  referrerpolicy="no-referrer"
                  src="./assets/img/mail.png"
                  @click="goUrl('mailto:fufuture@proton.me')"
                  alt="Email"
                  title="Email"
              />

            </div>

          </div>
          <div class="group_31 flex-col">
            <img class="group_31_img"
                 src="./assets/img/SketchPng07a4a3009072907529c1357faabce0cac82dbb40d9a7839db9e3eb8940eccb12.png"/>
          </div>

        </div>


        <div class="image-wrapper_12 flex-row justify-between">
          <img
              class="label_11"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPng9f16abb02c903e1e98749d71c8a5ece578abf7224cabf6c18bc9fc41bd1ad9b0.png"
          />
          <img
              class="image_22"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPng6a18f911b8db2d01b5fe58ea16c48ad44f40ae5b6764e54f046621cc4a756b2f.png"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import axios from "axios"

export default {
  data() {
    return {
      loopData0: [
        {lanhutext0: '0 BTC', lanhutext1: this.$t('BTC 24-hour trading volume summary')},
        {lanhutext0: '0 BTC', lanhutext1: this.$t('BTC holdings summary')},
        {lanhutext0: '0 ETH', lanhutext1: this.$t('ETH 24-hour trading volume summary')},
        {lanhutext0: '0 ETH', lanhutext1: this.$t('ETH holdings summary')}
      ],
      constants: {},
      notice: [],
      hotCoin: [
        {
          symbol: "FU",
          address: ["0x040f477b9bc3deab4a434631e1b98c193b7a1b5f"],
          pubRate: 0,
          priRate: 0,
          pub: 0,
          pri: 0,
          pubTotal: 0,
          priTotal: 0
        },
        {
          symbol: "FUU",
          address: ["0x239844ad46974cf7433685f2cba3f900ff59fc78"],
          pubRate: 0,
          priRate: 0,
          pub: 0,
          pri: 0,
          pubTotal: 0,
          priTotal: 0
        },
        {
          symbol: "USDT",
          address: ["0x55d398326f99059ff775485246999027b3197955"],
          pubRate: 0,
          priRate: 0,
          pub: 0,
          pri: 0,
          pubTotal: 0,
          priTotal: 0
        },
        {
          symbol: "ACA",
          address: ["0x0000000000000000000100000000000000000000"],
          pubRate: 0,
          priRate: 0,
          pub: 0,
          pri: 0,
          pubTotal: 0,
          priTotal: 0
        },
      ],
      sliderValue: 1,
      isShowLang: false,
      marqueeKey: 0,
      roundLogo: [
        require("./assets/img/SketchPng785547c0c0c1befa915bbaec8efc2bb8b72473fffe89434ec489d25f9b8e8237.png"),
        require("./assets/img/bevm2.svg"),
        require("./assets/img/SketchPnge95bd9a0d88244e2c6d09b06ced58897326dfb71014de754c0065b8fa4d748b2.png"),
        require("./assets/img/acala.svg"),
        require("./assets/img/AIA.png"),
        require("./assets/img/arbitrum.png"),
        require("./assets/img/base.png"),
        require("./assets/img/bnb.png"),
        require("./assets/img/Chainlink-Logo-White.png"),
        require("./assets/img/coin98.png"),
        require("./assets/img/conflex.png"),
        require("./assets/img/DUCK LOGO-Yellow&Black--01.png"),
        require("./assets/img/hashkey.png"),
        require("./assets/img/imtoken.png"),
      ],
      roundLogo2:[
        require("./assets/img/iotex.png"),
        require("./assets/img/mantle.png"),
        require("./assets/img/metamask.png"),
        require("./assets/img/mint.png"),
        require("./assets/img/monad.png"),
        require("./assets/img/morph.png"),
        require("./assets/img/okx.png"),
        require("./assets/img/polygon.png"),
        require("./assets/img/pyth.png"),
        require("./assets/img/rabby.png"),
        require("./assets/img/safepal.png"),
        require("./assets/img/supra.png"),
        require("./assets/img/tomo.png"),
        require("./assets/img/tp.png"),
        require("./assets/img/trust.png"),
      ],
      logoGap:document.body.clientWidth>800?50:17,
      logoKey0:0,
      logoKey1:0,
      hoverPause: false,
      changeQa:0,
      showLangTag: require("./assets/img/right.svg"),
      qa: [
        {
          title: this.$t("q1"),
          content: this.$t("a1"),
          isShow: false
        },
        {
          title: this.$t("q2"),
          content: this.$t("a2"),
          isShow: false
        }, {
          title: this.$t("q3"),
          content: this.$t("a3"),
          isShow: false
        }
      ]
    };
  },
  methods: {
    onSwiper() {

    },
    onSlideChange() {

    },
    showQa(key) {
      const img = document.getElementById("qa_" + key);
      let isShow = this.qa[key].isShow;
      img.src = isShow ? require("./assets/img/right.svg") : require("./assets/img/down.svg");
      this.qa[key].isShow = !isShow
      document.getElementById("content_" + key).style.display = isShow ? "none" : "block";
    },
    showLang() {
      this.isShowLang = !this.isShowLang;
      this.showLangTag = !this.isShowLang ? require("./assets/img/right.svg") : require("./assets/img/down.svg");
    },
    changeLang(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem("lang", lang);
      // this.changeQa+=1;
      this.qa= [
        {
          title: this.$t("q1"),
          content: this.$t("a1"),
          isShow: false
        },
        {
          title: this.$t("q2"),
          content: this.$t("a2"),
          isShow: false
        }, {
          title: this.$t("q3"),
          content: this.$t("a3"),
          isShow: false
        }
      ]
      this.loopData0[0].lanhutext1=this.$t('BTC 24-hour trading volume summary');
      this.loopData0[1].lanhutext1=this.$t('BTC holdings summary');
      this.loopData0[2].lanhutext1=this.$t('ETH 24-hour trading volume summary');
      this.loopData0[3].lanhutext1=this.$t('ETH holdings summary');

      this.getNotice();

    },
    async getNotice() {
      let res = await axios.get("https://admin.fufuture.io/fn.php?action=getData");
      if (res.data.code != 0 || !res.data.data || res.data.data.length == 0) {
        return;
      }

      let notice = [];
      let currentLang = localStorage.getItem("lang") ?? "zh"
      for (let i in res.data.data) {
        let item = res.data.data[i];
        let pushItem = {};
        for (let lang in item) {
          if (lang == currentLang) {
            pushItem.text = item[lang];
          }
          if (lang == "url") {
            pushItem.url = item[lang];
          }
        }
        notice.push(pushItem);
      }
      console.log("show notice is", notice,);
      this.notice = [...notice];
      this.marqueeKey += 1;

      setTimeout(()=>{
        document.getElementById("marquee-slider-loop").getElementsByClassName("src-components-marqueeSliderContainer-1UFI")[0].style.width="1200px";
      },200);

    },
    goUrl(url) {
      window.open(url, "__blank");
    },
    setHoverPause(isPaused) {
      this.hoverPause = isPaused;
    },
    async getAllData() {
      let allData = await axios.get("https://a.fufuture.io/allData");
      if (!allData) {
        return;
      }
      console.log("all data is", allData);
      allData = allData.data;
      if (allData["outData"]) {

        let btc24 = parseFloat(allData["outData"].BTC24);
        let btcAll = parseFloat(allData["outData"].BTCALL);

        let eth24 = parseFloat(allData["outData"].ETH24);
        let ethAll = parseFloat(allData["outData"].ETHALL);

        btc24 = this.changeNum2E(btc24);
        btcAll = this.changeNum2E(btcAll);
        eth24 = this.changeNum2E(eth24);
        ethAll = this.changeNum2E(ethAll);

        if(btc24){
          this.loopData0[0].lanhutext0=btc24 + " BTC";
        }
        if(btcAll){
          this.loopData0[1].lanhutext0=btcAll + " BTC";
        }
        if(eth24){
          this.loopData0[2].lanhutext0=eth24 + " ETH";
        }
        if(ethAll){
          this.loopData0[3].lanhutext0=ethAll + " ETH";
        }


      }

      if (allData["poolOutData"]) {
        let poolData = allData["poolOutData"];
        let addressCoin = {};
        let indexMap = {"FU": 0, "FUU": 1, "USDT": 2, "ACA": 3};
        for (let i in this.hotCoin) {
          for (let j in this.hotCoin[i].address) {
            addressCoin[this.hotCoin[i].address[j]] = indexMap[this.hotCoin[i].symbol];
          }
        }
        for (let i in poolData) {
          this.hotCoin[addressCoin[i]].pub += parseFloat(poolData[i].pubAvailable);
          this.hotCoin[addressCoin[i]].pubTotal += parseFloat(poolData[i].pubTotal);
          this.hotCoin[addressCoin[i]].priTotal += parseFloat(poolData[i].priTotal);
          this.hotCoin[addressCoin[i]].pri += (parseFloat(poolData[i].priTotal) - parseFloat(poolData[i].priLocked));
        }

        for (let i in this.hotCoin) {
          this.hotCoin[i].pubRate = Math.ceil(this.hotCoin[i].pub * 100 / this.hotCoin[i].pubTotal);
          this.hotCoin[i].priRate = Math.ceil(this.hotCoin[i].pri * 100 / this.hotCoin[i].priTotal);
        }
        console.log("hot coin is", this.hotCoin);
      }
    },
    changeNum2E(num) {
      if (num > 1000000000) {
        return parseFloat((num / 1000000000).toFixed(3)) + "B";
      }
      if (num > 1000000) {
        return parseFloat((num / 1001000).toFixed(3)) + "M";
      }
      if (num > 1000) {
        return parseFloat((num / 1000).toFixed(3)) + "K";
      }
      return parseFloat(num.toFixed(3));
    }
  },
  created() {
    this.getNotice();
    this.getAllData();
  },
  mounted() {
    let isMobile=false;
    window.onresize=()=>{
      if(document.body.clientWidth<=768){
        if(!isMobile){
          this.logoGap=17;
          isMobile=true;
          this.logoKey0+=1;
          this.logoKey1+=1;
          setTimeout(()=>{
            document.getElementById("marquee-slider-loop2").style.overflow="revert";
            document.getElementById("marquee-slider-loop3").style.overflow="revert";

            document.getElementById("marquee-slider-loop").getElementsByClassName("src-components-marqueeSliderContainer-1UFI")[0].style.width="1200px";

            document.getElementsByClassName("slider-btn-left")[0].innerHTML=`<img src="./slide_left.svg" width="18" height="18"/>`;
            document.getElementsByClassName("slider-btn-right")[0].innerHTML=`<img src="./slide_right.svg" width="18" height="18"/>`;
          },500)



        }
      }else{
        if(isMobile){
          this.logoGap=50;
          isMobile=false;
          this.logoKey0+=1;
          this.logoKey1+=1;
          setTimeout(()=>{
            document.getElementById("marquee-slider-loop2").style.overflow="revert";
            document.getElementById("marquee-slider-loop3").style.overflow="revert";

            document.getElementById("marquee-slider-loop").getElementsByClassName("src-components-marqueeSliderContainer-1UFI")[0].style.width="1200px";

          },500)
          document.getElementsByClassName("slider-btn-left")[0].innerHTML=`<img src="./slide_left.svg" width="34" height="34"/>`;
          document.getElementsByClassName("slider-btn-right")[0].innerHTML=`<img src="./slide_right.svg" width="34" height="34"/>`;
        }
      }
    }

    document.getElementById("marquee-slider-loop2").style.overflow="revert";
    document.getElementById("marquee-slider-loop3").style.overflow="revert";

    setTimeout(()=>{
      let showWidth=document.body.clientWidth<768?18:34;
      document.getElementsByClassName("slider-btn-left")[0].innerHTML=`<img src="./slide_left.svg" width="${showWidth}" height="${showWidth}"/>`;
      document.getElementsByClassName("slider-btn-right")[0].innerHTML=`<img src="./slide_right.svg" width="${showWidth}" height="${showWidth}"/>`;
    },50)
  }
};
</script>
<style scoped lang="css" src="./assets/index.css"/>
<style>
@media only screen and (max-width: 800px) {
  .ant-dropdown {
    width: 100% !important;
    background: #121212 !important;
    border-radius: 0;
  }

  .menu-content {
    background: #121212 !important;
    padding-left: 40px !important;
    padding-bottom: 40px !important;
  }

}

</style>
